import React from 'react';
import Button from '@material-ui/core/Button';
import {withStyles} from "@material-ui/core";
import {Styles} from "../../../../config/design/styles";
import {connect, setStore} from "trim-redux";
import Dialog from "@material-ui/core/Dialog/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent/DialogContent";
import {withSnackbar} from "notistack";
import {withRouter} from "react-router";
import FormControlLabel from "@material-ui/core/FormControlLabel/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox/Checkbox";
import Typography from "@material-ui/core/Typography/Typography";
import {defaultVariabls} from "../../../../config";
import FormControl from "@material-ui/core/FormControl/FormControl";
import LoadingButton from "../../../components/elements/LoadingButton";
import Grid from "@material-ui/core/Grid/Grid";
import SubTitle from "../../../components/elements/SubTitle";
import {Translate} from "../../../../config/Translate";
import ChevronRightRoundedIcon from '@material-ui/icons/ChevronRightRounded';
import UserChooserForShop from "./UserChooserForShop";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import IconButton from "@material-ui/core/IconButton/IconButton";
import axios from "axios";
class ChangeShopOwner extends React.Component{
    state= {
        open:false,
        SubmitLoading:false,
        user:null,
    };
    classes = this.props.classes;
    async handleSubmit(){
        await this.setState({
            SubmitLoading:true,
        })
        let loginToken = localStorage.getItem('ACT');
        if(loginToken !== null){
            let config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };
            let data = new FormData();
            data.append('shop_id', this.props.shop_id);
            data.append('user_id', this.state.user.id);
            await axios.post(`${defaultVariabls.url}/shop/changeOwner`,data, config)
                .then(response => {
                    window.location.reload()
                })
                .catch(error => {
                    this.setState({
                        SubmitLoading:false
                    })
                })
        }else {
            setStore({
                isAuth : false,
                user : null,
                loading:false
            });
            this.setState({
                loading:false
            })
        }

    }
    handleCloseDialog(){
        this.setState({
            open:false
        })
    }
    render(){
        let{open,SubmitLoading,user} = this.state;
        let {shop_id} = this.props;
        return (
            <>
                <Button
                    color="secondary"
                    variant="contained"
                    style={{marginTop:10}}
                    onClick={() => this.setState({open:true})}
                >
                    {Translate.changeShopOwner}
                </Button>
                <Dialog
                    open={open}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    maxWidth={'xs'}
                    fullWidth
                    onClose={() => this.handleCloseDialog()}
                >
                    <DialogTitle id="alert-dialog-title">
                        {Translate.changeShopOwner}
                        <IconButton
                            onClick={() => this.handleCloseDialog()}
                            style={{position:"absolute",left:15,top:15}}
                            size="small"
                        >
                            <CloseRoundedIcon fontSize="small"/>
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Typography>{Translate.changeShopOwnerDesc}</Typography>
                                <Typography>{Translate.changeShopOwnerDesc2}</Typography>
                                <Typography>{Translate.changeShopOwnerDesc3}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <UserChooserForShop outPut={(user) => this.setState({user})}/>
                            </Grid>

                            <Grid item xs={12}>
                                <LoadingButton
                                    variant="contained"
                                    color="primary"
                                    disabled={!user}
                                    onClick={this.handleSubmit.bind(this)}
                                    loading={SubmitLoading}
                                >
                                    {Translate.changeShopOwner}
                                </LoadingButton>
                            </Grid>
                        </Grid>
                    </DialogContent>
                </Dialog>
            </>
        );
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user,
    primary_shop: state.primary_shop,
});
export default withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(ChangeShopOwner))));